import React, { useMemo } from 'react';

import { useTable, useSortBy, useFilters } from 'react-table';
import PropTypes from 'prop-types';
import SearchFilter from '~/components/Table/Filters/SearchFilter';
import { StatusBadge, TitleBadge } from './styles';
import SelectColumnFilterForStatus from './components/SelectFilterForStatus';

export default function Table({ data }) {
  const columns = useMemo(
    () => [
      {
        Header: 'Display Name',
        accessor: 'displayName',
        disableFilters: true,
      },
      {
        Header: 'Color',
        accessor: 'exteriorColor',
        disableFilters: true,
      },
      {
        Header: 'Mileage',
        accessor: 'mileage',
        disableFilters: true,
      },
      {
        Header: 'VIN',
        accessor: 'vin',
      },
      {
        Header: 'Title',
        accessor: item => {
          let status;
          if (Number(item.title) === 1) {
            status = 'yes';
          } else if (Number(item.title) === 0) {
            status = 'no';
          } else {
            status = '?????';
          }
          return <TitleBadge value={status}>{status}</TitleBadge>;
        },
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: 'Status',
        accessor: item => {
          let status;
          if (Number(item.activeSubscriptions) === 1) {
            status = 'subscribed';
          } else if (Number(item.activeSubscriptions) === 0) {
            status = 'available';
          } else {
            status = 'attention';
          }
          return <StatusBadge value={status}>{status}</StatusBadge>;
        },
        Filter: SelectColumnFilterForStatus,
        filter: 'status',
        disableSortBy: true,
        // sortType: (A, B) => {
        //   if (A.original.activeSubscriptions > B.original.activeSubscriptions) {
        //     return 1;
        //   }
        //   if (A.original.activeSubscriptions < B.original.activeSubscriptions) {
        //     return -1;
        //   }
        //   if (A.original.price < B.original.price) {
        //     return 1;
        //   }
        //   if (A.original.price > B.original.price) {
        //     return -1;
        //   }
        //   return 0;
        // },
      },
      {
        Header: 'Actions',
        accessor: 'actions',
        disableFilters: true,
        disableSortBy: true,
      },
    ],
    []
  );
  const filterTypes = useMemo(
    () => ({
      status: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id];
          return rowValue !== undefined &&
            row.values[id].props !== undefined &&
            row.values[id].props.children !== undefined
            ? String(row.values[id].props.children)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true;
        });
      },
    }),
    []
  );

  const defaultColumn = useMemo(() => ({ Filter: SearchFilter }), []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      defaultColumn,
      filterTypes,
      data,
    },
    useFilters,
    useSortBy
  );
  return (
    <>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  {/* Add a sort direction indicator */}

                  {column.isSorted ? (
                    <span>{column.isSortedDesc ? ' 🔽' : ' 🔼'}</span>
                  ) : (
                    ' '
                  )}
                  {column.canFilter && <div> {column.render('Filter')} </div>}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};
